<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
        <v-form @submit.prevent="saveRace" novalidate class="elevation-2 pa-3 race-form">
          <v-text-field
              v-model="race.time"
              label="Czas"
              placeholder="H:M:S"
              :error="hasErrors('time')"
              :error-messages="getErrors('time')"
          >
            <i slot="prepend" v-tooltip="'Czas'" class="fi flaticon-minutes"></i>
          </v-text-field>
          <v-text-field
              v-model="race.place"
              label="Miejsce"
              :error="hasErrors('place')"
              :error-messages="getErrors('place')"
          >
            <i slot="prepend" v-tooltip="'Miejsce'" class="text-icon">M</i>
          </v-text-field>
          <v-textarea
              v-model="race.post_remarks"
              label="Informacje dodatkowe"
              :error="hasErrors('post_remarks')"
              :error-messages="getErrors('post_remarks')"
              auto-grow
              box
          >
            <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
          </v-textarea>
          <v-btn type="submit" color="primary">Zapisz</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {doneRace} from '../plan/api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'

export default {
  props: {
    raceData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      errors: {},
      race: {
        id: this.raceData.id,
        time: this.raceData.time || undefined,
        place: this.raceData.place || undefined,
        post_remarks: this.raceData.post_remarks || undefined
      }
    }
  },
  computed: {
    ...mapGetters([
      'runner'
    ])
  },
  created () {
    this.initRace()
  },
  methods: {
    initRace () {
      this.race = {...this.raceData}
    },
    saveRace () {
      let promise = doneRace(this.runner, this.race).then((data) => {
        this.$emit('success', data)
        this.edit = false
        iziToast.show({
          message: 'Wynik został zmieniony',
          color: 'green'
        })
        return data
      })
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/races/RaceResultsForm.vue